// extracted by mini-css-extract-plugin
export default {"content":"EmptySection_content__yvltf","icon":"EmptySection_icon__6UFF4"};